'use client';

import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

export type ViewMode = 'grid' | 'feed' | 'map';

type ViewModeContextValue = {
  viewMode: ViewMode;
  setViewMode: Dispatch<SetStateAction<ViewMode>>;
};

const ViewModeContext = createContext<ViewModeContextValue | null>(null);

// Never persisted: every SRP load starts on the list; feed and map are per-visit opt-ins (HP-9340).
export function SearchViewModeProvider({ children }: { children: ReactNode }) {
  const [viewMode, setViewMode] = useState<ViewMode>('grid');
  const value = useMemo(() => ({ viewMode, setViewMode }), [viewMode]);
  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useSrpViewMode(): ViewModeContextValue {
  const ctx = useContext(ViewModeContext);
  if (!ctx) {
    return { viewMode: 'grid', setViewMode: () => {} };
  }
  return ctx;
}
